import { FC } from 'react';
import i18next from 'i18next';
import styled from 'styled-components';

const InfoBox = styled.span`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.3px;
`;

const LinkBox = styled(InfoBox)`
  margin: 0;
`;

const TosContainer = styled.div`
  color: ${({ theme }) => theme.white.a10};
`;

export const StyledLink = styled.a`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.white.a10};
  letter-spacing: 0.3px;
  margin: 0 5px;
  text-decoration: underline;
`;

interface Props {
  t: i18next.TFunction;
  showCreditCardNeededBox?: boolean;
}

const TosAndDataPrivacyInfoBox: FC<Props> = ({ t, showCreditCardNeededBox }) => (
  <TosContainer>
    {showCreditCardNeededBox && (
      <InfoBox data-translation="x.signup.infos.no_credit_card_needed">
        {t('x.signup.infos.no_credit_card_needed')}
      </InfoBox>
    )}
    <InfoBox data-translation="x.signup.infos.tos_accept.title">
      {t('x.signup.infos.tos_accept.title')}
    </InfoBox>
    <LinkBox>
      <StyledLink
        target="_blank"
        href={t('x.privacy_policy.link')}
        data-translation="x.signup.infos.imprint.title, x.imprint.link"
      >
        {t('x.privacy_policy.title')}{' '}
      </StyledLink>
      {t('x.signup.infos.connect_privacy_and_tos')}
      <StyledLink
        target="_blank"
        href={t('x.signup.infos.tos.link')}
        data-translation="x.signup.infos.tos.title, x.signup.infos.tos.link"
      >
        {' '}
        {t('x.signup.infos.tos.title')}
      </StyledLink>
      {t('x.signup.infos.german_split_sentence_end')}
    </LinkBox>
  </TosContainer>
);

export default TosAndDataPrivacyInfoBox;
